import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSalesForceCRUDActions } from '@mm/state/actions/SalesForceCRUDActions';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';

export const useTagsCommon = (tokenId?: number) => {
  const activeFbPageId = useSelector(activeFacebookPageIdSelector);
  const tagsEnabled = useSelector(
    (state: StoreState) => state.salesForce.tagsEnabled,
  );
  const { getAvailableTags } = useSalesForceCRUDActions();

  useEffect(() => {
    if (tokenId) {
      getAvailableTags(activeFbPageId, tokenId);
    }
  }, [activeFbPageId, tokenId, getAvailableTags]);

  return { tagsEnabled };
};
